import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render() {
        return (
            <tarot-top-bar class='js-top_bar'>
                <a href='/'>{this.renderImg()}</a>
                <a class='js-menu_toggle toggle_menu' onClick={this.toggle}>
                    <div class='icon'>
                        <span />
                        <span />
                        <span />
                        <span />
                    </div>
                </a>
            </tarot-top-bar>
        );
    }

    renderImg() {
        return (<img class='top_bar_logo' src='https://gfx.tarot.com/images/site/logo/logo.svg' />);
    }

    toggle = () => {
        const [action, label] = this.props.isOpen ? ['Close', 'X'] : ['Open', 'Hamburger'];

        this.props.trackEvent(['Navigation', action, label]);
        this.props.updateNavBar({
            isOpen: !this.props.isOpen,
            currentOpen: null,
        });
    }
}

const mapStateToProps = (state) => ({
    isOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].isOpen,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
    updateNavBar: payload => dispatch({ type: 'nav-bar-mobile:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-top-bar.js